import React, { useState, useEffect, useCallback } from 'react';
import { Box, Alert, Button, Typography, CircularProgress } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { getCurrentUser } from '../../services/authService';
import apiService from '../../services/apiService';
import PendingUsersDialog from './PendingUsersDialog';

const PendingRequestsBanner = () => {
  const user = getCurrentUser();
  const isApprover = user && (user.role === 'admin' || user.role === 'superadmin');

  const [count, setCount] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchCount = useCallback(async () => {
    try {
      const res = await apiService.get('/api/auth/pending-users');
      setCount((res.data || []).length);
    } catch {
      // silently ignore
    }
  }, []);

  useEffect(() => {
    if (!isApprover) return;
    fetchCount();
    const id = setInterval(fetchCount, 60 * 1000);
    return () => clearInterval(id);
  }, [isApprover, fetchCount]);

  if (!isApprover || count === 0) return null;

  return (
    <>
      <Alert
        severity="warning"
        icon={<PeopleAltIcon fontSize="inherit" />}
        sx={{
          borderRadius: 0,
          px: 3,
          py: 1,
          '& .MuiAlert-message': { display: 'flex', alignItems: 'center', gap: 2, width: '100%' }
        }}
        action={
          <Button
            size="small"
            variant="contained"
            color="warning"
            onClick={() => setDialogOpen(true)}
            sx={{ fontWeight: 600, textTransform: 'none', whiteSpace: 'nowrap' }}
          >
            Review Requests
          </Button>
        }
      >
        <Typography variant="body2" fontWeight={600}>
          {count} pending access request{count !== 1 ? 's' : ''} awaiting your approval
        </Typography>
      </Alert>

      <PendingUsersDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onCountChange={setCount}
      />
    </>
  );
};

export default PendingRequestsBanner;
